module.exports = __webpack_public_path__ + "img/composite3.b0c833a1.png";